import FAQPreview from "@/components/sections/FAQPreview";
import ClosingCTA from "@/components/sections/ClosingCTA";

export default function FAQPage() {
    return (
        <>
            <section className="ihx-warm-surface ihx-grid-overlay">
                <div className="ihx-container py-20 lg:py-28">
                    <span className="ihx-eyebrow">Frequently asked</span>
                    <h1 className="ihx-h-display mt-5 max-w-3xl">
                        Honest answers, before the <span className="ihx-italic">consultation.</span>
                    </h1>
                    <p className="ihx-lead mt-7 max-w-2xl">
                        Below are the questions most patients ask in their first email.
                        If yours isn’t covered, the Discovery Form captures it — and
                        you’ll hear from the clinical team within 24 working hours.
                    </p>
                </div>
            </section>
            <FAQPreview />
            <ClosingCTA />
        </>
    );
}
